import React, { useState, useEffect, useCallback } from "react";
import { ReactTinyLink } from "react-tiny-link";
import Pagination from "react-js-pagination";
import Progress from "react-progress-2";
import echo from "./socket";

import * as api from "./api/post";

import "./App.css";
import "react-progress-2/main.css";

const App = () => {
  const [posts, setPosts] = useState([]);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    viewPosts();
  }, []);

  const viewPosts = (pageNumber = 1) => {
    Progress.show();
    api
      .getPosts(pageNumber)
      .then((response) => {
        Progress.hide();
        setPosts(response.data);
        setPagination(response.meta);
      })
      .catch((err) => {
        Progress.hide();
        console.log(err);
        const error = err.response;
        console.error(error);
      });
  };

  useEffect(() => {
    loadIGJs();
    loadTwitterJs();
  }, [posts]);

  const loadIGJs = () => {
    let script = document.createElement("script");
    script.src = "//www.instagram.com/embed.js";
    document.head.appendChild(script);
  };

  const loadTwitterJs = () => {
    let script = document.createElement("script");
    script.async = true;
    script.src = "https://platform.twitter.com/widgets.js";
    document.head.appendChild(script);
  };

  echo.channel("live-wp-posts").listen("PostCreated", (e) => {
    setPosts([e.results, ...posts]);
  });

  window.scrollTo({ behavior: "smooth", top: "50px" });

  const renderContent = useCallback(
    posts?.map((item, index) => {
      let content = JSON.parse(item.content);
      return (
        <div className="col-12" key={index} style={{ marginBottom: "5px" }}>
          <span style={{ color: "#404040", fontSize: "14px" }}>
            {item.updated_at}
          </span>
          {content !== "" ? (
            <>
              <p
                className="post__description"
                dangerouslySetInnerHTML={{ __html: content }}
              ></p>
            </>
          ) : (
            <>
              <ReactTinyLink
                cardSize="large"
                showGraphic={true}
                maxLine={2}
                minLine={1}
                proxyUrl={"https://network.3news.com:8080"}
                url={item.post_url}
              />
            </>
          )}
          <hr />
        </div>
      );
    })
  );

  return (
    <div className="container">
      <Progress.Component
        style={{ background: "#99999978", height: "5px" }}
        thumbStyle={{ background: "#5900b3", height: "5px" }}
      />
      <div className="row" style={{ maxWidth: "650px", margin: "auto" }}>
        <div className="col-md-12 mt-5">
          <lottie-player
            src="https://assets5.lottiefiles.com/packages/lf20_uenrvn87.json"
            mode="bounce"
            background="transparent"
            speed="1.5"
            style={{ width: "100px", height: "100px" }}
            loop
            autoplay
          ></lottie-player>
        </div>
        <div className="col-md-12 mt-3">{renderContent}</div>
        <div className="col-md-12 mt-3">
          {posts && (
            <Pagination
              activePage={pagination?.current_page}
              totalItemsCount={pagination?.total ? pagination?.total : 0}
              itemsCountPerPage={pagination?.per_page}
              onChange={(pageNumber) => viewPosts(pageNumber)}
              itemClass="page-item"
              linkClass="page-link"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default App;
